export default __webpack_public_path__ + "static/media/tab4-image1.eee3173c.png";